import { useDispatch, useSelector } from 'react-redux';

import { CheckBox } from '@interstate/components/CheckBox';
import { Box } from '@interstate/components/Box';

import { kebabCase } from '@makemydeal/dr-common-utils';

import * as offerActionCreators from '@makemydeal/dr-dash-store/actions/offerActionCreators';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { dealLockHooks } from '@makemydeal/dr-dash-components';

const UPFRONT = 'UPFRONT';

const TotalTaxUpfront = () => {
    const dispatch = useDispatch();
    const taxOverrideUpfront = useSelector(offerReduxSelectors.getTaxOverrideUpfront);
    const isLocked = dealLockHooks.useIsDealLocked();

    const onChange = () => {
        dispatch(offerActionCreators.updatedTotalTaxUpfrontOverride(!taxOverrideUpfront));
    };
    return (
        <Box display="flex" alignItems="center" justifyContent="center" margin="0 1rem" paddingTop="2rem">
            <CheckBox
                sx={{
                    backgroundColor: 'inherit'
                }}
                data-testid={kebabCase(UPFRONT)}
                id={kebabCase(UPFRONT)}
                label={'Upfront'}
                name={kebabCase(UPFRONT)}
                onChange={onChange}
                checked={taxOverrideUpfront}
                value="1"
                disabled={isLocked}
            />
        </Box>
    );
};

export default TotalTaxUpfront;
